import { createNativeRequest, platform } from '@mx/core';
import { AxiosRequestConfig } from 'axios';

import { request } from '../request';
import {
  IGetFollowingItemListReq,
  IGetFollowingItemListResp,
  IGetMyCreaetNpcReq,
  IGetMyCreaetNpcResp,
  IGetSubscribingItemListResp,
  IGetUserChatPromptReq,
  IGetUserChatPromptResp,
  IGetUserLinkingListReq,
  IGetUserLinkingListResp,
  IGetUserProfileReq,
  IGetUserProfileResp,
  IGetUserSubscribingListReq,
  IUpdateUserChatPromptReq,
  IUpdateUserProfileResp,
  IUpdateUserProfileV2Req,
} from '../types';

export const postGetUserProfile = async (
  data: IGetUserProfileReq,
  config?: AxiosRequestConfig
): Promise<IGetUserProfileResp> => {
  const url = '/weaver/api/v1/user/get_user_profile';

  if (platform.isNativePlatform) {
    return createNativeRequest<IGetUserProfileResp>({
      method: 'POST',
      url,
      data,
    });
  }

  return await request.post(url, data, config);
};

export const postUpdateUserProfile = async (
  data: IUpdateUserProfileV2Req,
  config?: AxiosRequestConfig
): Promise<IUpdateUserProfileResp> => {
  const url = '/weaver/api/v2/user/update_user_profile';

  return await request.post(url, data, config);
};

export const postGetMyCreateNpc = async (
  data: IGetMyCreaetNpcReq,
  config?: AxiosRequestConfig
): Promise<IGetMyCreaetNpcResp> => {
  const url = '/weaver/api/v1/npc/get_my_create_npc';

  return await request.post(url, data, config);
};

export const postGetFollowingItemList = async (
  data: IGetFollowingItemListReq
): Promise<IGetFollowingItemListResp> => {
  const url = '/weaver/api/v1/relation/get_following_item_list';

  return await request.post(url, data);
};

export const postGetUserLinking = async (
  data: IGetUserLinkingListReq,
  config?: AxiosRequestConfig
): Promise<IGetUserLinkingListResp> => {
  const url = '/weaver/api/v1/relation/get_user_linking';

  return await request.post(url, data, config);
};

export const postGetUserSubscribing = async (
  data: IGetUserSubscribingListReq,
  config?: AxiosRequestConfig
): Promise<IGetSubscribingItemListResp> => {
  const url = '/weaver/api/v1/relation/get_user_subscribing';

  return await request.post(url, data, config);
};

export const postUpdateUserChatPrompt = async (
  data: IUpdateUserChatPromptReq,
  config?: AxiosRequestConfig
): Promise<void> => {
  const url = '/weaver/api/v1/user/update_user_chat_prompt';

  return await request.post(url, data, config);
};

export const postGetUserChatPrompt = async (
  data: IGetUserChatPromptReq,
  config?: AxiosRequestConfig
): Promise<IGetUserChatPromptResp> => {
  const url = '/weaver/api/v1/user/get_user_chat_prompt';

  return await request.post(url, data, config);
};
